var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ItemPreviewI18nKeys, OccasionI18nKeys, data, getPromotionDetailTypeForModel, getPromotionTypeForModel, i18n) {var promotionType = getPromotionTypeForModel(data);
var promotionTypeI18nKey;
var promotionTypeI18nData;
switch(promotionType) {
  case 'UptoMonetaryDiscount':
    promotionTypeI18nKey = ItemPreviewI18nKeys['Up to {{monetaryDiscount}} off'];
    promotionTypeI18nData = { monetaryDiscount: i18n.formatCurrency(data.MoneyAmountOff, data.CurrencyCode) };
    break;
  case 'MonetaryDiscount':
    promotionTypeI18nKey = ItemPreviewI18nKeys['{{monetaryDiscount}} off'];
    promotionTypeI18nData = { monetaryDiscount: i18n.formatCurrency(data.MoneyAmountOff, data.CurrencyCode) };
    break;
  case 'UptoPercentDiscount':
    promotionTypeI18nKey = ItemPreviewI18nKeys['Up to {{percentDiscount}} off'];
    promotionTypeI18nData = { percentDiscount: i18n.formatPercent(data.PercentOff / 100) };
    break;
  case 'PercentDiscount':
    promotionTypeI18nKey = ItemPreviewI18nKeys['{{percentDiscount}} off'];
    promotionTypeI18nData = { percentDiscount: i18n.formatPercent(data.PercentOff / 100) };
    break;
}
var promotionTypeFormatted = i18n.getString(promotionTypeI18nKey, promotionTypeI18nData);

var promotionDetail = getPromotionDetailTypeForModel(data);
var promotionDetailI18nKey = '';
var promotionDetailI18nData;
var promotionDetailFormatted = '';
var hasPromotionDetail = promotionDetail !== 'None';
if (hasPromotionDetail) {
  switch (promotionDetail) {
    case 'OnOrdersOver':
      promotionDetailI18nKey = ItemPreviewI18nKeys['On orders over {{amount}}'];
      promotionDetailI18nData = { amount: i18n.formatCurrency(data.OrdersOverAmount, data.CurrencyCode) };
      break;
    case 'PromotionCode':
      promotionDetailI18nKey = ItemPreviewI18nKeys['Code {{promotionCode}}'];
      promotionDetailI18nData = { promotionCode: data.PromotionCode };
      break;
  }
  promotionDetailFormatted = i18n.getString(promotionDetailI18nKey, promotionDetailI18nData);
}

var dateRangeI18nKey = '';
var dateRangeI18nData;
var startDateFormatted = '';
var endDateFormatted = '';
var DATE_FORMAT_MM_DD = 'MM/dd';
function formatISODateString(isoDatetimeString) {
  const dateToUse = i18n.parseDate(
    isoDatetimeString.substring(0, 10),
    {
      raw: 'yyyy-MM-dd',
      timeZone: null,
    }
  );

  return i18n.formatDate(dateToUse, { skeleton: "MMMd", timeZone: null });
}

var dateRangeFormatted = '';
var hasDateRange = data.PromotionStartDate || data.PromotionEndDate;
if (hasDateRange) {
  if (data.PromotionStartDate) {
    startDateFormatted = formatISODateString(data.PromotionStartDate);
  }
  if (data.PromotionEndDate) {
    endDateFormatted = formatISODateString(data.PromotionEndDate);
  }
  if (startDateFormatted && endDateFormatted) {
    if (startDateFormatted !== endDateFormatted) {
      dateRangeI18nKey = ItemPreviewI18nKeys['Valid {{startDate}} - {{endDate}}'];
      dateRangeI18nData = { startDate: startDateFormatted, endDate: endDateFormatted };
    } else {
      dateRangeI18nKey = ItemPreviewI18nKeys['Valid {{date}}'];
      dateRangeI18nData = { date: startDateFormatted };
    }
  } else if (startDateFormatted) {
    dateRangeI18nKey = ItemPreviewI18nKeys['Starts {{startDate}}'];
    dateRangeI18nData = { startDate: startDateFormatted };
  } else if (endDateFormatted) {
    dateRangeI18nKey = ItemPreviewI18nKeys['Ends {{endDate}}'];
    dateRangeI18nData = { endDate: endDateFormatted };
  }
  dateRangeFormatted = i18n.getString(dateRangeI18nKey, dateRangeI18nData);
}

var hasOccasion = data.Occasion !== 'None';
var hasSecondLine = hasPromotionDetail || hasDateRange;

pug_html = pug_html + "\u003Cdiv class=\"itemTemplate-text\"\u003E";
if (hasOccasion) {
pug_html = pug_html + (pug.escape(null == (pug_interp = i18n.getString(OccasionI18nKeys[data.Occasion])) ? "" : pug_interp)) + ":\n";
}
pug_html = pug_html + (pug.escape(null == (pug_interp = promotionTypeFormatted) ? "" : pug_interp)) + " " + (pug.escape(null == (pug_interp = data.PromotionItem) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (hasSecondLine) {
pug_html = pug_html + "\u003Cdiv class=\"itemTemplate-text\"\u003E";
if (hasPromotionDetail) {
pug_html = pug_html + (pug.escape(null == (pug_interp = promotionDetailFormatted) ? "" : pug_interp));
if (hasDateRange) {
pug_html = pug_html + "\n·\n";
}
}
if (hasDateRange) {
pug_html = pug_html + (pug.escape(null == (pug_interp = dateRangeFormatted) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}}.call(this,"ItemPreviewI18nKeys" in locals_for_with?locals_for_with.ItemPreviewI18nKeys:typeof ItemPreviewI18nKeys!=="undefined"?ItemPreviewI18nKeys:undefined,"OccasionI18nKeys" in locals_for_with?locals_for_with.OccasionI18nKeys:typeof OccasionI18nKeys!=="undefined"?OccasionI18nKeys:undefined,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined,"getPromotionDetailTypeForModel" in locals_for_with?locals_for_with.getPromotionDetailTypeForModel:typeof getPromotionDetailTypeForModel!=="undefined"?getPromotionDetailTypeForModel:undefined,"getPromotionTypeForModel" in locals_for_with?locals_for_with.getPromotionTypeForModel:typeof getPromotionTypeForModel!=="undefined"?getPromotionTypeForModel:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return pug_html;};
module.exports = template;